import { addStateHandlers, flowMax, SimpleUnchangedProps } from 'ad-hok'
import { getContextHelpers, toObjectKeys } from 'ad-hok-utils'
import { User } from 'shared/src/api/types'
import { typedAs } from 'shared/src/utils/typedAs'

interface LaunchPayload {
  user?: User
}

const [addLaunchContextProviderBase, addLaunchContext] = getContextHelpers<{
  hasMountedInitialPage: boolean
  setLaunchPayload: (payload: LaunchPayload) => void
  initialUser: User | undefined
}>(toObjectKeys(['hasMountedInitialPage', 'initialUser', 'setLaunchPayload']))

export const addLaunchContextProvider: SimpleUnchangedProps = flowMax(
  addStateHandlers(
    {
      hasMountedInitialPage: false,
      initialUser: typedAs<User | undefined>(undefined),
    },
    {
      setLaunchPayload:
        () =>
        ({ user }: LaunchPayload) => ({
          hasMountedInitialPage: true,
          initialUser: user,
        }),
    }
  ),
  addLaunchContextProviderBase
)

export { addLaunchContext }
